import { Component } from '@angular/core';

@Component({
    templateUrl: './my-courses-help.component.html',
    styleUrls: ['./my-courses-help.component.scss'],
    standalone: false
})
export class MyCoursesHelpComponent{}

